module.exports = __webpack_public_path__ + "static/media/hero2.7f503285.png";